<h2 mat-dialog-title>Mettre à jour via export / import</h2>
<mat-dialog-content>
  <p class="mb-4">
    Cette importation ne permet pas d'ajouter de nouveaux articles. Elle sert uniquement à réimporter le fichier
    d'export, après modification des colonnes autorisées.
  </p>
  <ul class="ml-5 list-disc text-sm mb-4">
    <li>Téléchargez d'abord le fichier via le bouton « Exporter ».</li>
    <li>Modifiez uniquement: Libellé, Informations complémentaires, Fin de validité.</li>
    <li>Ne changez pas la référence ni l'identifiant interne.</li>
  </ul>

  <div class="mb-4">
    <button mat-stroked-button color="primary" (click)="exportTemplate()">
      <mat-icon>file_download</mat-icon>
      Exporter le fichier modèle
    </button>
  </div>

  <mat-form-field appearance="outline" class="w-full">
    <mat-label>Fichier d'export modifié (.xlsx)</mat-label>
    <input matInput [value]="selectedFile?.name || ''" placeholder="Choisir un fichier" readonly />
    <button mat-icon-button matSuffix (click)="fileInput.click()" aria-label="Choisir un fichier">
      <mat-icon>attach_file</mat-icon>
    </button>
  </mat-form-field>
  <input #fileInput type="file" accept=".xlsx" hidden (change)="onFileChange($event)" />

  <mat-hint *ngIf="fileNameHintInvalid" class="text-warn">
    Ce fichier ne semble pas provenir de l'export (nom attendu contenant « ProductBulkUpdate »).
  </mat-hint>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Annuler</button>
  <button mat-raised-button color="primary" (click)="import()" [disabled]="!selectedFile">Importer</button>
</mat-dialog-actions>
